import {Active} from "finhelper";

export const filterGroups = (mainGroups, search) => {
    if (!search.trim()) return mainGroups;

    const normalizedSearch = search.toLowerCase().trim();

    return mainGroups.map(mainGroup => {
        // Обрабатываем только если в mainGroup есть .groups
        if (!mainGroup.groups) return mainGroup;

        const filteredGroups = mainGroup.groups
            .map(group => {
                // Фильтруем активы внутри каждой группы
                const filteredActives = group.actives?.filter(active => {
                    const name = Active.getName(active); // например, метод из библиотеки finhelper
                    const typeName = active.attributes?.type_text || '';
                    const customName = active.attributes?.name_text || '';

                    return (
                        name?.toLowerCase()?.includes(normalizedSearch) ||
                        typeName.toLowerCase()?.includes(normalizedSearch) ||
                        customName.toLowerCase()?.includes(normalizedSearch)
                    );
                }) || [];

                // Возвращаем обновлённую группу, но только если в ней есть активы после фильтрации
                if (filteredActives.length > 0) {
                    return {
                        ...group,
                        actives: filteredActives
                    };
                }

                // Если активов нет — исключаем группу
                return null;
            })
            .filter(Boolean); // Убираем null-значения (группы без совпадений)

        // Возвращаем новый mainGroup с отфильтрованными группами
        return {
            ...mainGroup,
            groups: filteredGroups
        };
    });
};